<template>
  <div>
    <b-navbar
      class="topNav"
      type="light">
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto pt-3 mr-4">
        <b-nav-item 
          v-if="!isMobile()" 
          href="https://meet.corenexa.com/download/">Download</b-nav-item>
        <b-nav-item href="https://rhelp.corenexa.com/Video">Support</b-nav-item>
        <b-nav-item-dropdown
          id="lang"
          :text="languageName"
          menu-class="noFocus"
          class="nofocus"
          right>
          <b-dropdown-item
            v-for="(_lang, index) in languages"
            :key="index"
            @click="changeLanguage(_lang.value, _lang.name)">
            {{ _lang.name }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
    <b-container fluid>
      <b-row 
        align-h="center" 
        class="pb-5">
        <b-col
          v-if="isSupported()"
          cols="12"
          sm="10"
          md="8"
          lg="5"
          xl="4"
          class="mt-sm-5 loginMaxWidth">
          <b-form
            class="bg-white p-4 rounded shadow light login mt-2"
            @submit="onSubmit"
          >
            <div class="mx-auto my-md-4 text-center logoSize">
              <logo/>
            </div>
            <h3 class="text-center mt-1 mb-5 joinText">Join Meeting</h3>
            <div class="form-label-group light">
              <b-form-input
                id="meetingID"
                :placeholder="$t('LOGIN.MEETING_PLACEHOLDER')"
                v-model="form.meetingID"
                autocomplete="off"
                type="text"
                required
                autofocus
                class="form-control-light"
              />
              <label for="meetingID">{{ $t('LOGIN.MEETING_PLACEHOLDER') }}</label>
            </div>

            <div
              v-if="!meta_token"
              class="form-label-group light">
              <b-form-input
                id="someName"
                :placeholder="$t('LOGIN.NAME_PLACEHOLDER')"
                v-model="form.name"
                type="text"
                required
                class="form-control-light"
              />
              <label for="someName">{{ $t('LOGIN.NAME_PLACEHOLDER') }}</label>
            </div>

            <div class="form-label-group light">
              <b-form-input
                id="pinId"
                v-model="form.pin"
                placeholder="Entry Pin"
                type="text"
                autocomplete="off"
                class="form-control-light"
              />
              <label for="pinId">{{ $t('LOGIN.PIN_PLACEHOLDER') }}</label>
              <small class="form-text text-muted"/>
            </div>
            <hr>
            <b-button
              ref="joinRef"
              :disabled="!isSupported()"
              type="submit"
              class="ml-auto d-block"
              variant="primary-light"
            >
              {{ $t('LOGIN.BUTTON_JOIN') }}
            </b-button>
          </b-form>
        </b-col>
        <b-col
          v-else
          cols="12"
          sm="10"
          md="8"
          lg="5"
          xl="4"
          class="mt-sm-5"
        >
          <div class="bg-white p-4 rounded shadow text-danger-light login mt-2 text-center">
            <div class="m-4">
              <logo/>
            </div>
            <p v-if="isMobile()">This web browser is not supported on your device. Please try Chrome on Android, and Safari on iOS.</p>
            <p v-if="!isMobile()">This web browser is not supported on your device. Please try Chrome, Firefix, Edge, Opera or Safari.</p>
          </div>
        </b-col>
      </b-row>
      <div class="footer clearfix">
        <div class="float-left"><small>© 2020 all rights reserved</small></div>
        <div class="float-right"><a 
          target="_blank" 
          href="https://www.corenexa.com/privacy-policy">Privacy Policy</a></div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { getBrowser, isSupported, isMobile, isIos } from "../functions/browserDetails"
import { loadStorageData, getItem, setItem, getMetaToken,saveMetaToken } from "../functions/storageManager"
import { ref, reactive, watch, onMounted } from "@vue/composition-api"
import Logo from "../icons/Logo"

export default {
  name: 'Login',
  components: {
    Logo
  },
  setup(props, context) {
    const meetingIds = ref([])
    const language = ref('en')
    const languageName = ref('English')
    const languages = ref([{value:"en",name:"English"},{value:"fr",name:"Français"},{value:"sk",name:"Slovenčina"},{value:"es",name:"Español"},{value:"ro",name:"Româna"},{value:"it",name:"Italiano"},{value:"pt",name:"Português"},{value:"pt_BR",name:"PortuguêsBR"},{value:"de",name:"Deutsch"},{value:"fi",name:"Suomi"},{value:"tr",name:"Türkçe"},{value:"nl",name:"Nederlands"},{value:"zh_Hans",name:"简体中文"},{value:"zh_Hant",name:"繁體中文"},{value:"ru",name:"Русский"},{value:"ar",name:"لغة"},{value:"el",name:"Ελληνικά"},{value:"ko",name:"한국어}"},{value:"ja",name:"日本語"},{value:"ur",name:"زبان"},{value:"ne",name:"भाषा"},{value:"kk",name:"Қазақтілі"},{value:"hi",name:"हिन्दी"}])
    const meta_token = ref('');
    const form = reactive ({
      meetingID: '',
      name: '',
      pin: '',
      directly: false
    })
    document.body.style.backgroundColor = "#f8f8f8";

    const browser = getBrowser()
    loadStorageData()
    if (getItem('meetings')) {
      meetingIds.value = getItem('meetings').split(",")
    }
    if (getItem('language') !== undefined) {
      context.root.$i18n.locale = getItem('language')
    } else if (context.root.$route.query.language) {
      context.root.$i18n.locale = context.root.$route.query.language
    } else if (window.default_language != "") {
      context.root.$i18n.locale = window.default_language
    }

    if (getItem('languageName') !== undefined) {
      languageName.value = getItem('languageName')
    } else if (window.default_language != "") {
      languageName.value = window.default_languageName
    }


    language.value = context.root.$i18n.locale


    onCreate(context)

    function onCreate(context) {
      if (context.root.$route.query) {
        form.meetingID = context.root.$route.query.meetingID
        form.pin = context.root.$route.query.pin
        meta_token.value = context.root.$route.query.r ? context.root.$route.query.r : getMetaToken()
        if(meta_token.value) {
          saveMetaToken(meta_token)
          if (form.meetingID)
            enterMeeting()
        }
      }
      createManifest('')
      if (getItem('directly') !== undefined) form.directly = getItem('directly')
      setItem('debug', 'error')
    }
    function createManifest (branding) {
      let manifestName = 'static/manifest' + branding + '.webmanifest?rnd=132'
      document.getElementById('myManifest').href = manifestName
    }

    function onSubmit (evt) {
      evt.preventDefault()
      enterMeeting()
    }
    function enterMeeting() {
      let index = meetingIds.value.findIndex(value => value == form.meetingID)
      if (index < 0) {
        if(meetingIds.value.length > 4) {
          meetingIds.value.splice(4, meetingIds.value.length - 4)
        }
        meetingIds.value.splice(0, 0, form.meetingID)
        setItem('meetings', meetingIds.value.toString())
      } else {
        meetingIds.value.splice(index, 1)
        meetingIds.value.splice(0, 0, form.meetingID)
        setItem('meetings', meetingIds.value.toString())
      }

      setItem('meetingData', form)
      context.root.$router.push({ path: 'startMeeting', query: { directly: form.directly } })
    }
    function changeLanguage (value, name) {
      context.root.$i18n.locale = value
      languageName.value = name
      setItem('language', value)
      setItem('languageName', name)
    }
    watch(() => form.directly, (directly) => { setItem('directly', directly) })
    return {
      language,
      changeLanguage,
      form,
      meetingIds,
      browser,
      isSupported,
      isMobile,
      loadStorageData,
      getItem,
      setItem,
      onSubmit,
      languages,
      languageName,
      meta_token
    }
  }
}
</script>
<style scoped>
.topNav {
  font-size: 12px;
  padding: .75rem .75rem;
  background-color: transparent!important;
  box-shadow: none!important;
}
.login hr {
  margin: 32px -25px 16px;
}
.logo{
  max-width: 200px;
  line-height: 1;
}
.topNav {
  font-weight: 600;
  padding: 0;
}
.navbar-toggler-icon {
  color: #000000;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue